var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenu2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7143 0.899414H2.57146C1.62469 0.899414 0.857178 1.66693 0.857178 2.6137V21.4708C0.857178 22.4176 1.62469 23.1851 2.57146 23.1851H18C18.9468 23.1851 19.7143 22.4176 19.7143 21.4708V13.7566M0.857178 18.0423H19.7143M6.00003 5.18513H9.42861M6.00003 9.47084H7.71432M15.4186 12.9094L10.2757 13.8351L11.1328 8.62364L18.3842 1.4065C18.5436 1.24582 18.7332 1.11829 18.9422 1.03125C19.151 0.944222 19.3751 0.899414 19.6013 0.899414C19.8278 0.899414 20.0519 0.944222 20.2607 1.03125C20.4696 1.11829 20.6592 1.24582 20.8185 1.4065L22.6356 3.22364C22.7964 3.383 22.924 3.5726 23.0109 3.78151C23.098 3.99041 23.1427 4.21448 23.1427 4.44079C23.1427 4.66709 23.098 4.89116 23.0109 5.10005C22.924 5.30895 22.7964 5.49857 22.6356 5.65793L15.4186 12.9094Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu2);
export default __webpack_public_path__ + "static/media/iconMenu2.7448250ded41a7d079ba453a6c6cdade.svg";
export { ForwardRef as ReactComponent };